module.exports = (__webpack_require__("J2rE"))(76);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/date-fns/index.js from dll-reference utils_dll
// module id = wuJz
// module chunks = 0